module.exports = __webpack_public_path__ + "components/rewards/panda-optics/static/logo-87b7e3c1e52e079f33af7e2224bfc7b8.jpg";